import React, { useEffect, useReducer, useState } from 'react';
import GameManager from '../cvp-webgames-core/GameManager';

import UIOverlay from '../components/UIOverlay';
import ReactTools from '../cvp-webgames-core/Misc/ReactTools';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
//import Scenario1, {Scenario3, Scenario4, Scenario5, Scenario6, Scenario7, Scenario8, Scenario9, Scenario10, Scenario11, Scenario12} from '../scenarios/scenario1/Scenario1';
import { constants } from '../misc/constants';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import { GameDataConfig } from '../cvp-webgames-core/Misc/interfaces';
import { PageType } from '../misc/tools';
import { globals } from '../misc/globals';
import Tools from '../cvp-webgames-core/Misc/Tools';
import Scenario1 from '../scenarios/scenario1';
import Scenario2 from '../scenarios/scenario2';
import Scenario3 from '../scenarios/scenario3';
import Scenario4 from '../scenarios/scenario4';
import Scenario5 from '../scenarios/scenario5';

const apiKey = '104ce847dacc1b6fe5ac7da4df1cecbb' //secret

const MuteBttn = (props: any) => { 
	const [forceUpdate, setForceUpdate] = useState(false);
	return (
		<div  style={{
			width: '5%',
			position: 'absolute',
			top: '33%',
			right: '0%',
			cursor: 'pointer',
			zIndex: 10
		}}
			tabIndex={0} 
			role='button' 
			aria-label={`Turn muting of audio ` + (globals.isMuted ? 'off' : 'on')} 
			id='mute-bttn' 
			onClick={() => {
				globals.isMuted = !globals.isMuted;
				props.onClick();
				setForceUpdate(!forceUpdate);

			}}>
			<img className="pointer modal-disable-select" src={globals.isMuted ? './assets/images/audioOff.svg' : './assets/images/audioOn.svg'} />
		</div>
	);
};


const reducer = (state: any, action: any) => {
	let result = ReactTools.generalReducer(state, action);
	switch (action.type) {
		case 'hideAllUIs':
			result = {...state, hideAllUIs: true};
			break; 
		case 'setGameManager':
			result = {...state, gameManager: action.value};
			break; 
		}
	return result;
};
 
const GamePage = (props: any) => { 
	// const [forceUpdate, setForceUpdate] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		gameManager: null,
		forceUpdate: true,
		hideAllUIs: false
	});

	(window as any).forceUpdateCC = () => {
		if((window as any).forceUpdateInternalCCComp) {
			(window as any).forceUpdateInternalCCComp();
		}
	}

    (window as any).onToggleMute = () => {
        globals.isMuted = !globals.isMuted;
        state.gameManager.SoundManager.mutedAudio = globals.isMuted;
        state.gameManager.environment.props.muted = globals.isMuted;
		(window as any)['muted-audio'] = globals.isMuted;
		if((window as any).onSetMute) {
			(window as any).onSetMute(globals.isMuted)
		}
        dispatch({
            type: 'forceUpdate'
        });
    }

    (window as any).isMuted = () => {
        return globals.isMuted;
    }

    (window as any).mapDivEnterToClick = (evt: any) => {
        return Tools.mapDivEnterToClick(evt);
    }

	useEffect(() => {
		if(state.gameManager) {
			if(typeof state.gameManager.currentScenarioIndex === 'undefined' || state.gameManager.currentScenarioIndex === null || state.gameManager.currentScenarioIndex === -1) {
				state.gameManager.loadScenario(props.scenarioId);
			}

		} else {
			let url = new URL(window.location.href);
			let search_params = url.searchParams;
			let w: any = search_params.get('w');
			if(w && w !== PageType.MainMenu && w !== PageType.Nothing) {
				console.warn('init game page');
				let gm = new GameManager();
			
				gm.customData = {
					dispatch: dispatch,
					updateWindow: props.updateWindow
				};
				let environment = new VideoEnvironment(gm, dispatch);
				environment.init();
				gm.init([
					new Scenario1(gm, PageType.Scenario1.toString()),
					new Scenario2(gm, PageType.Scenario2.toString()),
					new Scenario3(gm, PageType.Scenario3.toString()),
					new Scenario4(gm, PageType.Scenario4.toString()),
					new Scenario5(gm, PageType.Scenario5.toString()),
				], environment, new JsxUIManager(gm), new ReactSoundManager(), true, '', {}, constants.debugMode);
				dispatch({
					type: 'setGameManager',
					value: gm
				});
			}
		}
	}, [state.gameManager]);
	
	// }, [state.gameManager, state.forceUpdate]);
  
	return (
		state.gameManager ? (
			<div id="game-container" style={{
				width: '100%',
				height: '100%'
			}}>
				{state.gameManager.environment.render((memory: string) => {
                    dispatch({
                        type: 'forceUpdate'
                    });
                }, () => {
					dispatch({
						type: 'forceUpdate'
					});
				}, {updateWindow: props.updateWindow, shouldShowDebugBttns: () => {
					return false;
				}})}
				<UIOverlay updateWindow={props.updateWindow} gameManager={state.gameManager} scenarioId={props.scenarioId} forceUpdate={() => {
					dispatch({
						type: 'forceUpdate',
						value: state.gameManager
					});
				}} hideAllUIs={state.hideAllUIs}></UIOverlay>
			</div>) : (<div>Initialing Page...</div>)
	);
};



export default GamePage;
